function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.6654 6.74997H9.2487V1.3333C9.2487 0.649968 8.68203 0.0833015 7.9987 0.0833015C7.31536 0.0833015 6.7487 0.649968 6.7487 1.3333V6.74997H1.33203C0.648698 6.74997 0.0820312 7.31663 0.0820312 7.99997C0.0820312 8.6833 0.648698 9.24997 1.33203 9.24997H6.7487V14.6666C6.7487 15.35 7.31536 15.9166 7.9987 15.9166C8.68203 15.9166 9.2487 15.35 9.2487 14.6666V9.24997H14.6654C15.3487 9.24997 15.9154 8.6833 15.9154 7.99997C15.9154 7.31663 15.3487 6.74997 14.6654 6.74997Z",
  fill: "black",
  fillOpacity: 0.4
});

var SvgAddIndexChartLight = function SvgAddIndexChartLight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAddIndexChartLight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AddIndexChartLight.16ce5558.svg";
export { ForwardRef as ReactComponent };